export const socketUrl = window.REACT_APP_WS_API !== 'REPLACE_REACT_APP_WS_API' ? window.REACT_APP_WS_API : process.env.REACT_APP_WS_API || 'http://localhost:8040';

